export default __webpack_public_path__ + "static/media/Nico Martin.a586b66b.png";